import { h } from 'preact'
import { lazy, Suspense } from 'preact/compat'

const CategoryBreadcrumbs = lazy(() => import('@features/elastic/components/BreadcrumbsCategory'))
const ManufacturerBreadcrumbs = lazy(() =>
	import('@features/elastic/components/BreadcrumbsManufacturer'),
)
const SearchBreadcrumbs = lazy(() => import('@features/elastic/components/BreadcrumbsSearch'))
const TagBreadcrumbs = lazy(() => import('@features/elastic/components/BreadcrumbsTag'))

export default function getPageBreadcrumbs(pageType) {
	switch (pageType) {
		case 'category':
			return (
				<Suspense>
					<CategoryBreadcrumbs />
				</Suspense>
			)

		case 'manufacturer':
			return (
				<Suspense>
					<ManufacturerBreadcrumbs />
				</Suspense>
			)

		case 'search':
			return (
				<Suspense>
					<SearchBreadcrumbs />
				</Suspense>
			)

		case 'tag':
			return (
				<Suspense>
					<TagBreadcrumbs />
				</Suspense>
			)

		default:
			return null
	}
}
